import React from "react";
import {isEqual} from "underscore";


class SearchField extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            value: props.value
        };
        this.change = this.change.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.commit = this.commit.bind(this);
    }

    change(event) {
        this.setState({value: event.target.value});
    }

    handleKeyPress(event) {
        if(event.key !== 'Enter'){
            return;
        }

        this.commit();
    }

    commit() {
        this.props.onCommit(this.state.value);
    }

    componentDidUpdate(prevProps) {
        if(!isEqual(this.props.value, prevProps.value)) {
            this.setState({value: this.props.value});
        }
    }

    render() {
        return (
            <div className={"input-group " + this.props.className}>
                <input
                    type="text"
                    className="form-control"
                    id="query"
                    placeholder="GLN, PLZ, GTIN, ..."
                    value={this.state.value}
                    onKeyPress={this.handleKeyPress}
                    onChange={this.change}/>
                <span className="input-group-btn">
                    <button className="btn btn-default" type="button" onClick={this.commit}>
                        <i className="fa fa-search">&nbsp;</i>
                    </button>
                </span>
            </div>
        );
    }
}

export default SearchField;



// WEBPACK FOOTER //
// ./src/admin/components/SearchField.js